import { BAM_PRODUCT_MODE } from "./constants";

export const getStyleSheetForBamProduct = ({ mode }) => {
  /* eslint-disable */
  return `
    :host {
        width: 100%;
        height: 100%;
        display: block;
    }

    div.wrapper {
       height: 100%;
       width: 100%;
       position: relative;
    }
    div.iframe-wrapper {
        overflow: hidden;

       ${ mode === BAM_PRODUCT_MODE.MODAL ? ` 
        margin: 0;
        padding: 0;
        background-color: #fff;

        width:      var(--bam-product-modal-width, 40vw);
        min-width:  var(--bam-product-drawer-min-width, 400px);
        max-width:  var(--bam-product-modal-max-width, 620px);

        height:     var(--bam-product-modal-height, 80vh);
        min-height: var(--bam-product-modal-min-height, 480px);
        max-height: var(--bam-product-modal-max-height, 100%);
       ` : '' }

       ${ mode === BAM_PRODUCT_MODE.DRAWER ? `
        margin: 0;
        padding: 0;
        background-color: #fff;

        width: var(--bam-product-drawer-width, 400px);
        min-width: var(--bam-product-drawer-min-width, 400px);
        max-width: var(--bam-product-drawer-max-width);

        height: var(--bam-product-drawer-height, 100vh);
        min-height: var(--bam-product-drawer-min-height);
        max-height: var(--bam-product-drawer-max-height);
       ` : '' }

       ${ mode === BAM_PRODUCT_MODE.INLINE ? ` 
        margin: 0;
        padding: 0;
        background-color: #fff;
        width: 100%;
        height: 100%;
        `: '' }
    }

    div.content-wrapper {
        margin: 0;
        padding: 16px;
        background-color: #fff;
    }

    dialog.modal {
        padding: 0;
        border: none;
        border-radius: var(--bam-product-corner-radius, 16px);
        background: none;
    }

    dialog.drawer {
        padding: 0;
        border: none;
        background: none;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        max-height: 100%;
        height: 100%;
        margin-right: 0;

        /* for animation */
    }

    @media (max-width: 430px) {
       dialog.modal, dialog.drawer {
         border-radius: 0;
         width: 100%;
         height: 100%;
         max-width: 100%;
         max-height: 100%;
       }

       div.iframe-wrapper {
         min-width: 320px;
         width: 100vw;

         min-height: 100%;
         height: 100%;
       }
    }

    dialog.modal::backdrop, dialog.drawer::backdrop {
        background: rgba(0, 0, 0, 0.5);
    }

    dialog.modal[open] {
        animation: fade-in 0.15s ease-in-out forwards;
    }
    dialog.modal[open]::backdrop {
        animation: fade-in 0.15s ease-in-out forwards;
    }

    dialog.drawer:not(.closing)[open]::backdrop {
        animation: fade-in 0.15s ease-in-out forwards;
    }
    dialog.drawer.closing[open]::backdrop {
        animation: fade-out 0.15s ease-in-out forwards;
    }
    dialog.drawer:not(.closing)[open] {
        animation: open-drawer-from-right-side 0.15s ease-in-out forwards;
    }
    dialog.drawer.closing[open] {
        animation: close-drawer-to-right-side 0.15s ease-in-out forwards;
    }

    @keyframes fade-in {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes fade-out {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }


    @keyframes open-drawer-from-right-side {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }
    @keyframes close-drawer-to-right-side {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(100%);
        }
    }

    .bam-product-close-button {
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        z-index: 10000001;
        cursor: pointer;
        color: #333;
        background: white;
        border: none;
        line-height: 1;
        font-size: 24px;
        opacity: 0.4;
        user-select: none;
    }

    .bam-product-close-button.is-hidden {
        display: none;
    }
     `;
  /* eslint-enable */
};
